import ContactDetails from "@shared/profile-components/ContactDetails";
import CompanyOverview from "../components/CompanyOverview";
import CompanyTable from "../components/CompanyTable";
import CompanyTabs from "../components/Tabs";
import { profileTypeEnum } from "./enum.js";
import { CompanyProfileHierarchy } from "../components/CorporateHeirarchy";
import { isValidCoordinates, transformData } from "@helpers/profileHelper";
import { redirectionTypePayload } from "@core/global/global-country-dictionary";
import { toast } from "react-toastify";
import { getIntelUrl } from "@utils/intelUrl";
import trackingEventDictionary from "@core/dictionary/tracking-event";
import DueDiligenceReports from "../components/DueDiligenceReport/DueDiligenceReports";
import FeatureBlockUI from "../components/FeatureBlockUI/FeatureBlockUI";
import ProfileAISummary from "../components/ProfileAISummary/ProfileAISummary.jsx";
const targetSVG = "M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z";

export const renderCompanyPanelData = (activePanelId, countDetails = {}, isSalesForce, handlePanelClick) => {
  let renderCompanyPanelData = {
    importers: <CompanyTabs isSalesForce={isSalesForce} handlePanelClick={handlePanelClick} />,
    exporters: <CompanyTabs isSalesForce={isSalesForce} handlePanelClick={handlePanelClick} />,
    logistic_partners: <CompanyTabs isSalesForce={isSalesForce} handlePanelClick={handlePanelClick} />,
    corporate_heirarchy: <CompanyProfileHierarchy />,
    due_diligence_reports: <DueDiligenceReports countDetails={countDetails} />,
    contact_details: <ContactDetails isSalesForce={isSalesForce} eventEnum={trackingEventDictionary.companyProfilePageSearchContactsTabSearchContacts} profileType={profileTypeEnum.company} countDetails={countDetails} />,
  };
  return renderCompanyPanelData[activePanelId];
};

export const renderCompanyProfileTabsAltUI = (activePanelId) => {
  let tabsData = {
    due_diligence_reports: <FeatureBlockUI activePanelId="due_diligence_reports" />,
    corporate_heirarchy: <FeatureBlockUI activePanelId="corporate_heirarchy" />,
  };
  return tabsData[activePanelId];
};

export const renderCompanyTabs = (activeTabId, setShowTabs, shipmentDistributionData, setShipmentDistributionData, isSalesForce, viewShipmentClick, setViewShipmentClick, shipmentDistributionLoader, setShipmentDistributionLoader, handlePanelClick, activePanelId) => {
  let renderCompanyTabs = {
    overview: <CompanyOverview shipmentDistributionData={shipmentDistributionData} setShipmentDistributionData={setShipmentDistributionData} viewShipmentClick={viewShipmentClick} setViewShipmentClick={setViewShipmentClick} shipmentDistributionLoader={shipmentDistributionLoader} setShipmentDistributionLoader={setShipmentDistributionLoader} handlePanelClick={handlePanelClick} />,
    trade_country: <CompanyOverview currentKey="trade_country" shipmentDistributionData={shipmentDistributionData} setShipmentDistributionData={setShipmentDistributionData} viewShipmentClick={viewShipmentClick} setViewShipmentClick={setViewShipmentClick} shipmentDistributionLoader={shipmentDistributionLoader} setShipmentDistributionLoader={setShipmentDistributionLoader} handlePanelClick={handlePanelClick} />,
    port: <CompanyOverview currentKey="port" shipmentDistributionData={shipmentDistributionData} setShipmentDistributionData={setShipmentDistributionData} viewShipmentClick={viewShipmentClick} setViewShipmentClick={setViewShipmentClick} shipmentDistributionLoader={shipmentDistributionLoader} setShipmentDistributionLoader={setShipmentDistributionLoader} handlePanelClick={handlePanelClick} />,
    location: <CompanyOverview currentKey="location" shipmentDistributionData={shipmentDistributionData} setShipmentDistributionData={setShipmentDistributionData} viewShipmentClick={viewShipmentClick} setViewShipmentClick={setViewShipmentClick} shipmentDistributionLoader={shipmentDistributionLoader} setShipmentDistributionLoader={setShipmentDistributionLoader} handlePanelClick={handlePanelClick} />,
    trading_partner: <CompanyTable tableName="Trading Partners" isSalesForce={isSalesForce} />,
    hs_code: <CompanyTable tableName="HS codes" tabType={redirectionTypePayload.sixDigitHsCode} hideCountry={true} isSalesForce={isSalesForce} />,
    freight_forwarder: <CompanyTable tableName="Freight Forwarders" hideShipment={false} hideDataSource={true} dataSourceColumnHeading={"Total Shipment Occurrence"} isSalesForce={isSalesForce} />,
    vocc: <CompanyTable tableName="VOCCs" hideShipment={false} hideDataSource={true} hideCountry={true} setShowTabs={setShowTabs} dataSourceColumnHeading={"Total Shipment Occurrence"} isSalesForce={isSalesForce} />,
    nvocc: <CompanyTable tableName="NVOCCs" hideShipment={false} hideDataSource={true} dataSourceColumnHeading={"Total Shipment Occurrence"} isSalesForce={isSalesForce} />,
    vessel: <CompanyTable tableName="Vessels" isSalesForce={isSalesForce} />,
    importers: <CompanyTable tableName="Consignees" isSalesForce={isSalesForce} />,
    exporters: <CompanyTable tableName="Shippers" isSalesForce={isSalesForce} />,
    ai_summary: <ProfileAISummary activePanelId={activePanelId} />,
  };
  return renderCompanyTabs[activeTabId];
};

export const getTradeLanesChartData = (mapData) => {
  let data = [];
  let imageData = [];
  let imageDataFrom = new Set();
  if (mapData && Array.isArray(mapData)) {
    for (let i = 0; i < mapData.length; i++) {
      const { doc_count } = mapData[i];
      const { key: fromKey, countryCode, latitude: fromLatitude, longitude: fromLongitude } = mapData[i].from;
      const { latitude: toLatitude, longitude: toLongitude, key: toKey } = mapData[i].to;
      if (isValidCoordinates(fromLatitude, fromLongitude, toLongitude, toLatitude) && doc_count > 0) {
        let obj = {
          portName: transformData(toKey, true, false),
          primaryPortName: transformData(fromKey, true, false),
          shipments: parseInt(doc_count),
        };
        obj.id = countryCode;
        obj.multiGeoLine = [
          [
            { latitude: fromLatitude, longitude: fromLongitude },
            { latitude: toLatitude, longitude: toLongitude },
          ],
        ];
        obj.shipments = parseInt(doc_count);
        data.push({ ...obj });
        let imgDataObj = {
          ...obj,
          id: toKey,
          svgPath: targetSVG,
          title: transformData(toKey, true, false),
          latitude: toLatitude,
          longitude: toLongitude,
          scale: 1,
          radius: 6,
          primaryPortName: null,
          shipments: null,
        };
        let imgDataObjFrom = {
          id: fromKey,
          svgPath: targetSVG,
          title: transformData(fromKey, true, false),
          latitude: fromLatitude,
          longitude: fromLongitude,
          scale: 1,
          radius: 6,
        };
        imageData.push({ ...imgDataObj });
        const stringifiedItem = JSON.stringify(imgDataObjFrom);
        imageDataFrom.add(stringifiedItem);
      }
    }
  }
  const fromArr = Array.from(imageDataFrom).map((item) => JSON.parse(item));
  imageData.push(...fromArr);
  return {
    mapData: data,
    imageData,
  };
};

export const getLineCoordinates = (lineSeries, latitude, longitude) => {
  const imageLatitudes = [];
  const imageLongitudes = [];
  lineSeries.mapLines.each(function (mapLine) {
    const { latitude: lineLatitude, longitude: lineLongitude } = mapLine.multiGeoLine[0][1] || {};
    if (latitude === lineLatitude && longitude === lineLongitude) {
      imageLatitudes.push(mapLine.multiGeoLine[0][0].latitude);
      imageLongitudes.push(mapLine.multiGeoLine[0][0].longitude);
    }
  });
  return [imageLatitudes, imageLongitudes];
};

export const updateMapLine = (mapLine, isActive) => {
  mapLine.line.strokeOpacity = isActive ? 1 : 0.02;
  mapLine.arrow.opacity = isActive ? 1 : 0.02;
};

export const updateMapImagesOpacity = (mapImages, latitudes, longitudes) => {
  mapImages.each(function (mapImage) {
    mapImage.opacity = latitudes.includes(mapImage.latitude) && longitudes.includes(mapImage.longitude) ? 1 : 0.02;
  });
};

export const restoreMapImagesOpacity = (mapImages) => {
  mapImages.each(function (mapImage) {
    mapImage.opacity = 1;
  });
};

export const resetMapLinesAppearance = (mapLines) => {
  mapLines.each(function (mapLine) {
    mapLine.line.strokeOpacity = 0.4;
    mapLine.arrow.opacity = 1;
  });
};

const getTradeCountryChartData = (mapData) => {
  let data = [];
  if (mapData && Array.isArray(mapData)) {
    for (let i = 0; i < mapData.length; i++) {
      if (mapData[i] && mapData[i].countryCode && mapData[i].doc_count) {
        let obj = {};
        obj.id = mapData[i].countryCode;
        obj.value = parseInt(mapData[i].doc_count);
        data.push({ ...obj });
      }
    }
  }
  return {
    mapData: data,
    imageData: [],
  };
};

const getTradePortsChartData = (mapData) => {
  let data = [];
  if (mapData && Array.isArray(mapData)) {
    const maxDocCountObject = mapData.reduce(
      (max, current) => {
        return current.doc_count > max.doc_count ? current : max;
      },
      { doc_count: -Infinity }
    );
    for (let i = 0; i < mapData.length; i++) {
      const { doc_count, key, latitude, longitude } = mapData[i];
      if (key && doc_count) {
        let obj = {};
        obj.id = key;
        obj.svgPath = targetSVG;
        obj.latitude = latitude;
        obj.longitude = longitude;
        obj.title = transformData(key, true, false);
        obj.scale = getScaleValue(parseInt(doc_count), maxDocCountObject.doc_count);
        obj.shipments = parseInt(doc_count);
        data.push({ ...obj });
      }
    }
  }
  return {
    mapData: data,
    imageData: [],
  };
};

const getScaleValue = (shipment, maxValue) => {
  const minScale = 0.8;
  const maxScale = 1.8;

  if (shipment >= maxValue) {
    return 1.8;
  }

  // Calculate the scale based on the ratio
  const scale = minScale + (maxScale - minScale) * (shipment / maxValue);
  // Ensure the scale stays within the specified range
  return Math.min(maxScale, Math.max(minScale, scale));
};

export const preparePortsMapData = (category, data) => {
  switch (category) {
    case "trade_country":
      return getTradeCountryChartData(data);
    case "location":
      return getTradePortsChartData(data);
    case "trade_port":
      return getTradePortsChartData(data);
    case "trade_lane":
      return getTradeLanesChartData(data);
    default:
      return {
        mapData: [],
        imageData: [],
      };
  }
};

export const navigateTo = (item, companyId) => {
  if (companyId !== item.company_id) {
    let type = new URLSearchParams(window.location.search).get("type");
    let country = new URLSearchParams(window.location.search).get("country") || item.country_code;
    let url = getIntelUrl() + "companies/" + item.slug + "/" + item.company_id + "?country=" + country + "&type=" + type + "&isSubs=true" + "&subsCheck=true";
    if (!!url && url !== "") {
      window.open(url, "_blank");
    } else {
      toast.error("Something went wrong");
    }
  }
};
